module.exports = __webpack_public_path__ + "static/media/main-list-location.11501e83.png";